<nz-drawer
  [(nzVisible)]="visible"
  nzPlacement="right"
  [nzTitle]="'builderScreen.aiSuggestions.title' |translateTA"
  [nzWidth]="420"
  [nzClosable]="true"
  (nzOnClose)="onClose()">
  

  <div class="ai-suggestions-content">
    

    <div class="component-info-header" *ngIf="selectedNode">
      <div class="component-type-info">
        <nz-tag [nzColor]="'blue'">
          {{ ('builderScreen.componentTypes.' + (selectedNode?.type || 'unknown')) |translateTA }}
        </nz-tag>
        <span class="component-id">ID: {{ selectedNode.id }}</span>
      </div>
      

      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        [nzLoading]="isLoading"
        (click)="refreshSuggestions()"
        [nz-tooltip]="'builderScreen.aiSuggestions.refresh' |translateTA">
        <nz-icon nzType="reload" nzTheme="outline"></nz-icon>
      </button>
    </div>


    <div class="loading-state" *ngIf="isLoading">
      <nz-spin nzSize="large">
        <div class="loading-content">
          <nz-icon nzType="robot" nzTheme="outline" style="font-size: 48px; color: #1890ff;"></nz-icon>
          <p>{{ 'builderScreen.aiSuggestions.analyzing' |translateTA }}</p>
        </div>
      </nz-spin>
    </div>


    <div class="suggestions-list" *ngIf="!isLoading && (suggestions$ | async) as suggestions">
      

      <div class="no-suggestions" *ngIf="suggestions.length === 0">
        <nz-empty
          nzNotFoundImage="simple"
          [nzNotFoundContent]="'builderScreen.aiSuggestions.noSuggestions' |translateTA">
          <div nz-empty-footer>
            <button 
              nz-button 
              nzType="primary" 
              nzSize="small"
              (click)="refreshSuggestions()">
              <nz-icon nzType="reload" nzTheme="outline"></nz-icon>
              {{ 'builderScreen.aiSuggestions.refresh' |translateTA }}
            </button>
          </div>
        </nz-empty>
      </div>


      <nz-card 
        *ngFor="let suggestion of suggestions; trackBy: trackBySuggestionId"
        class="suggestion-card"
        [class]="'impact-' + suggestion.impact"
        nzSize="small"
        [nzActions]="[actionApply, actionDismiss]">
        

        <div class="suggestion-content">

          <div class="suggestion-header">
            <div class="suggestion-icon">
              <nz-icon 
                [nzType]="getSuggestionIcon(suggestion)" 
                nzTheme="outline">
              </nz-icon>
            </div>
            
            <div class="suggestion-title-area">
              <h4 class="suggestion-title">{{ suggestion.title }}</h4>
              <div class="suggestion-meta">
                <nz-tag 
                  [nzColor]="getSuggestionColor(suggestion)"
                  nzSize="small">
                  {{ ('builderScreen.aiSuggestions.impact.' + suggestion.impact) |translateTA }}
                </nz-tag>
                <nz-tag 
                  nzColor="default"
                  nzSize="small">
                  {{ ('builderScreen.aiSuggestions.category.' + suggestion.category) |translateTA }}
                </nz-tag>
              </div>
            </div>
          </div>


          <p class="suggestion-description">{{ suggestion.description }}</p>


          <div class="property-changes" *ngIf="suggestion.propertyChanges && suggestion.propertyChanges.length > 0">
            <h5>{{ 'builderScreen.aiSuggestions.changes' |translateTA }}:</h5>
            <div class="changes-list">
              <div 
                *ngFor="let change of suggestion.propertyChanges" 
                class="change-item">
                <code class="property-name">{{ change.property }}</code>
                <nz-icon nzType="arrow-right" class="change-arrow"></nz-icon>
                <code class="property-value">{{ change.newValue }}</code>
              </div>
            </div>
          </div>


          <div class="confidence-score" *ngIf="suggestion.confidence">
            <span class="confidence-label">
              {{ 'builderScreen.aiSuggestions.confidence' |translateTA }}:
            </span>
            <nz-progress 
              [nzPercent]="suggestion.confidence * 100" 
              nzSize="small"
              [nzShowInfo]="false"
              [nzStrokeColor]="suggestion.confidence > 0.8 ? '#52c41a' : suggestion.confidence > 0.6 ? '#faad14' : '#ff4d4f'">
            </nz-progress>
            <span class="confidence-value">{{ (suggestion.confidence * 100) | number:'1.0-0' }}%</span>
          </div>
        </div>


        <ng-template #actionApply>
          <button 
            nz-button 
            nzType="primary" 
            nzSize="small"
            (click)="applySuggestion(suggestion)">
            <nz-icon nzType="check" nzTheme="outline"></nz-icon>
            {{ 'builderScreen.aiSuggestions.apply' |translateTA }}
          </button>
        </ng-template>

        <ng-template #actionDismiss>
          <button 
            nz-button 
            nzType="text" 
            nzSize="small"
            (click)="dismissSuggestion(suggestion, $event)">
            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
            {{ 'builderScreen.aiSuggestions.dismiss' |translateTA }}
          </button>
        </ng-template>
      </nz-card>
    </div>


    <div class="no-component-selected" *ngIf="!selectedNode">
      <nz-empty
        nzNotFoundImage="simple"
        [nzNotFoundContent]="'builderScreen.aiSuggestions.selectComponent' |translateTA">
      </nz-empty>
    </div>
  </div>
</nz-drawer>
